const plain = value => String(value || '').replace(/<br\s*\/?\s*>|<\/p>|<\/div>/gi,'\n').replace(/<[^>]*>/g,'').replace(/&nbsp;/gi,' ').replace(/&amp;/gi,'&');
const normalized = value => plain(value).normalize('NFKC').toLocaleLowerCase('en').replace(/[^\p{L}\p{N}]+/gu,' ').trim();
export function displayEventTitle(value) {
  return String(value || '').replace(/[0-9#*]\uFE0F?\u20E3|[\p{Extended_Pictographic}\p{Regional_Indicator}\p{Emoji_Modifier}\uFE0F\u200D\u{E0020}-\u{E007F}]/gu,'').replace(/\s+/g,' ').trim();
}
export function classifyEvent(row) {
  const description = plain(row.description);
  const title = plain(row.summary);
  const explicit = description.match(/^\s*SPRPLX_ORGANIZATION:\s*(.+)$/im)?.[1]?.trim();
  const name = normalized(title);
  let organization = '';
  if (/^wwe$/i.test(explicit || '') || /\bwwe\b|\bworld wrestling entertainment\b|\b(?:raw|smackdown|nxt|wrestlemania|royal rumble|summerslam|survivor series|money in the bank|elimination chamber|backlash|night of champions|crown jewel|wrestlepalooza)\b/.test(name)) organization='WWE';
  if (/^(?:aaa|lucha libre aaa)$/i.test(explicit || '') || /\b(?:aaa|triplemania|triplemanía|rey de reyes|guerra de titanes|verano de escandalo|verano de escándalo)\b/.test(name)) organization='AAA';
  if (!organization || /\b(?:insurance|roadside|auto club|baseball|earnings|stockholder|shareholder)\b/.test(name)) return null;
  if (/\b(?:press conference|earnings|stockholder|shareholder|birthday|podcast|watch party|fan fest|meet and greet|autograph|ticket sale|on sale)\b/.test(name)) return null;
  const major = organization === 'WWE'
    ? /\b(?:wrestlemania|royal rumble|summerslam|survivor series|money in the bank|elimination chamber|backlash|night of champions|clash (?:at the castle|in paris)|crown jewel|evolution|wrestlepalooza|wrestle dream|premium live event|ple)\b/.test(name)
    : /\b(?:triplemania|triplemanía|rey de reyes|guerra de titanes|verano de escandalo|verano de escándalo|heroes inmortales|héroes inmortales|lucha libre world cup)\b/.test(name);
  const special = /\b(?:saturday s main event|worlds collide|stand (?:and|deliver)|no mercy|halloween havoc|deadline|battleground|vengeance day|heatwave)\b/.test(name);
  const weekly = /\b(?:raw|smackdown|nxt|lucha libre aaa|aaa tv)\b/.test(name);
  const tour = /\b(?:road to|road to wrestlemania|holiday tour|live tour)\b/.test(name);
  const category=tour?'live':major?'major':special?'special':weekly?'weekly':'live';
  return {organization,category,defaultPriority:tour?20:major?100:special?60:weekly?10:20};
}

export const CALENDAR_ID = 'c_1931c2c0c3b15906813b5a893daaef3a3ac2a84a3f3c2936128d8a3886cd198a@group.calendar.google.com';
const DAY = 86400000;
const TTL = 300000;
const requests = new Map();
export const normalize = value => String(value || '').normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase('en');
export function safeLink(value, base = 'https://sprplx.com') {
  try {
    const raw = String(value || '').trim();
    if (!raw || /[\u0000-\u001f\\]/.test(raw) || raw.startsWith('//')) return '';
    const url = new URL(raw, base);
    if (url.username || url.password || url.protocol !== 'https:') return '';
    return url.href;
  } catch { return ''; }
}
export function metadata(description = '') {
  const text = String(description).replace(/<br\s*\/?\s*>|<\/p>|<\/div>/gi, '\n').replace(/<[^>]*>/g, '').replace(/&nbsp;/gi, ' ').replace(/&amp;/gi, '&');
  const result = { organization: '', tags: [], priority: 0, featured: false, link: '' };
  for (const line of text.split(/[\r\n]+/)) {
    const match = line.trim().match(/^SPRPLX_(ORGANIZATION|TAGS|PRIORITY|LINK|FEATURED):\s*(.*)$/i);
    if (!match) continue;
    const [, key, value] = match;
    if (key.toUpperCase() === 'ORGANIZATION') result.organization = value.trim().slice(0, 120);
    if (key.toUpperCase() === 'TAGS') result.tags = value.split(',').map(normalize).filter(Boolean).slice(0, 100);
    if (key.toUpperCase() === 'PRIORITY') result.priority = Math.max(-1000, Math.min(1000, Number(value) || 0));
    if (key.toUpperCase() === 'FEATURED') result.featured = normalize(value) === 'true';
    if (key.toUpperCase() === 'LINK') result.link = value.trim();
  }
  return result;
}
export function zonedTime(date, zone) {
  const parts = date.match(/^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2})(?::(\d{2}))?)?$/);
  if (!parts) return NaN;
  const values = parts.slice(1).map(x => Number(x || 0));
  const target = Date.UTC(values[0], values[1] - 1, values[2], values[3], values[4], values[5]);
  let guess = target;
  try {
    const formatter = new Intl.DateTimeFormat('en-US', {timeZone: zone, year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
    for (let i = 0; i < 4; i++) {
      const p = Object.fromEntries(formatter.formatToParts(guess).map(x => [x.type,x.value]));
      const actual = Date.UTC(+p.year,+p.month-1,+p.day,+p.hour,+p.minute,+p.second);
      const delta = target - actual;
      guess += delta;
      if (!delta) return guess;
    }
    return NaN;
  } catch { return NaN; }
}
export function timestamp(part, zone) {
  if (!part) return NaN;
  if (part.date) return zonedTime(part.date, part.timeZone || zone);
  if (typeof part.dateTime !== 'string') return NaN;
  return /(?:Z|[+-]\d{2}:\d{2})$/i.test(part.dateTime) ? Date.parse(part.dateTime) : zonedTime(part.dateTime, part.timeZone || zone);
}
export function parseEvents(items, zone = 'UTC') {
  const unique = new Map();
  for (const x of Array.isArray(items) ? items : []) {
    if (!x || x.status === 'cancelled') continue;
    const info = classifyEvent(x);
    if (!info) continue;
    const meta = metadata(x.description);
    const event = {id:String(x.id || ''),title:String(x.summary || ''),description:String(x.description || ''),location:String(x.location || ''),
      start:timestamp(x.start,zone),end:timestamp(x.end,zone),zone:x.start?.timeZone || zone,allDay:Boolean(x.start?.date),
      ...meta,organization:info.organization,category:info.category,defaultPriority:info.defaultPriority,
      explicitPriority:/^\s*SPRPLX_PRIORITY:/im.test(plain(x.description)),updated:Date.parse(x.updated || '') || 0};
    if (!event.title || !Number.isFinite(event.start) || !Number.isFinite(event.end) || event.end <= event.start) continue;
    const key = info.organization+'|'+normalized(event.title)+'|'+event.start;
    const old = unique.get(key);
    if (!old || old.updated < event.updated) unique.set(key,event);
  }
  return [...unique.values()].sort((a,b)=>a.start-b.start);
}
export function matchRank(event, product) {
  const terms = new Set((product?.terms || []).map(normalize));
  const org = normalize(event.organization);
  if (event.tags.some(tag => tag !== org && terms.has(tag))) return 2;
  if (org && terms.has(org)) return 1;
  return 0;
}
export function selectEvent(events, config, now = Date.now()) {
  let eligible = events.filter(e => e.end > now && e.start <= now + Math.min(90,config.windowDays || 90) * DAY && (!config.promotion || config.promotion === 'all' || e.organization === config.promotion) && (!config.majorOnly || e.category === 'major'));
  if (config.manualEventId) { const manual = eligible.find(e=>e.id===config.manualEventId); if (manual) return manual; }
  if (config.product && config.matching && config.productMode !== 'next') {
    const ranks = eligible.map(e => matchRank(e, config.product));
    const best = Math.max(0, ...ranks);
    if (best) eligible = eligible.filter(e => matchRank(e, config.product) === best);
    else if (config.productMode === 'hide') return null;
  }
  return eligible.sort((a,b) => {
    if (config.selection !== 'chronological' && config.productMode !== 'next') {
      const rank = Number(b.featured)-Number(a.featured) || ((b.explicitPriority || config.autoMajor === false ? b.priority : b.defaultPriority || b.priority) - (a.explicitPriority || config.autoMajor === false ? a.priority : a.defaultPriority || a.priority));
      if (rank) return rank;
    }
    return a.start-b.start || a.id.localeCompare(b.id);
  })[0] || null;
}
function cacheKey(config) {
  let hash = 2166136261;
  for (const c of config.calendar + config.apiKey + config.windowDays + (config.source || '') + (config.feedUrl || '')) hash = Math.imul(hash ^ c.charCodeAt(0), 16777619);
  return 'sprplx-events-v2-' + (hash >>> 0).toString(16);
}
export async function retrieve(config, fetcher = fetch, storage, now = Date.now()) {
  if (storage === undefined) { try { storage = globalThis.sessionStorage; } catch { storage = null; } }
  if (config.calendar !== CALENDAR_ID) throw new Error('Only SPRPLX Events is supported');
  const key = cacheKey(config);
  const existing = requests.get(key);
  if (existing && existing.expires > now) return existing.promise;
  try {
    const cached = JSON.parse(storage?.getItem(key) || 'null');
    if (cached && cached.expires > now && Array.isArray(cached.items)) return parseEvents(cached.items, cached.zone);
  } catch {}
  const promise = (async () => {
    if (config.source === 'feed') {
      const endpoint = safeLink(config.feedUrl);
      if (!endpoint) throw new Error('Configure secure feed URL');
      const response = await fetcher(endpoint,{credentials:'omit',signal:AbortSignal.timeout(12000)});
      if (!response.ok) throw new Error('Event feed unavailable');
      const data = await response.json();
      if (data.version !== 1 || data.calendarId !== CALENDAR_ID || !Array.isArray(data.items) || !Number.isFinite(Date.parse(data.generatedAt)) || Math.abs(now-Date.parse(data.generatedAt)) > 5400000) throw new Error('Invalid or stale event feed');
      try { storage?.setItem(key,JSON.stringify({expires:now+TTL,zone:data.timeZone || 'UTC',items:data.items})); } catch {}
      return parseEvents(data.items,data.timeZone || 'UTC');
    }
    const items = [];
    let token = '';
    let zone = 'UTC';
    for (let page = 0; page < 10; page++) {
      const url = new URL('https://www.googleapis.com/calendar/v3/calendars/' + encodeURIComponent(config.calendar) + '/events');
      url.search = new URLSearchParams({singleEvents:'true',orderBy:'startTime',showDeleted:'false',timeMin:new Date(now).toISOString(),timeMax:new Date(now + Math.min(90,config.windowDays || 90)*DAY).toISOString(),maxResults:'250', ...(token ? {pageToken:token} : {})});
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      let response;
      try { response = await fetcher(url.href, {headers:{'X-Goog-Api-Key':config.apiKey},signal:controller.signal,credentials:'omit'}); }
      finally { clearTimeout(timeout); }
      if (!response.ok) throw new Error('Calendar unavailable');
      const data = await response.json();
      if (data.items === undefined && typeof data.timeZone === 'string') data.items = [];
      if (!Array.isArray(data.items)) throw new Error('Invalid calendar response');
      items.push(...data.items);
      zone = data.timeZone || zone;
      token = data.nextPageToken || '';
      if (!token) break;
    }
    if (token) throw new Error('Calendar exceeds supported event window');
    const clean = items.map(({id,summary,description,location,start,end,status,updated,iCalUID,originalStartTime}) => ({id,summary,description,location,start,end,status,updated,iCalUID,originalStartTime}));
    try { storage?.setItem(key,JSON.stringify({expires:now+TTL,zone,items:clean})); } catch {}
    return parseEvents(clean, zone);
  })();
  requests.set(key,{expires:now+TTL,promise});
  try { return await promise; } catch (error) { requests.set(key,{expires:now+60000,promise}); throw error; }
}
if (typeof customElements !== 'undefined' && !customElements.get('sprplx-event-countdown')) {
  customElements.define('sprplx-event-countdown', class extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.events = [];
      this.token = (this.token || 0) + 1;
      this.eventKey = '';
      this.nextRefresh = 0;
      this.active = true;
      if (this.config.source === 'feed' ? !this.config.feedUrl : !this.config.calendar || !this.config.apiKey) {
        this.empty(this.config.editor ? this.config.labels.configure : this.config.fallback);
        return;
      }
      this.refresh();
      this.timer = setInterval(() => this.tick(),1000);
    }
    disconnectedCallback() { clearInterval(this.timer); this.timer = null; this.active = false; this.token++; }
    async refresh() {
      if (this.busy) return;
      this.busy = true;
      const token = this.token;
      try {
        const events = await retrieve(this.config);
        if (!this.active || token !== this.token) return;
        this.events = events;
        this.nextRefresh = Date.now()+TTL;
        this.tick();
      } catch {
        if (this.active && token === this.token) {
          this.events = [];
          this.nextRefresh = Date.now()+60000;
          this.empty(this.config.editor ? this.config.labels.error : this.config.fallback);
        }
      } finally { this.busy = false; }
    }
    empty(message) {
      this.querySelector('[data-event]').hidden = true;
      this.querySelector('[data-status]').textContent = message;
      this.querySelector('[data-status]').hidden = false;
      this.hidden = !this.config.editor && (this.config.hideEmpty || Boolean(this.config.product && this.config.matching && this.config.productMode === 'hide'));
      this.eventKey = '';
    }
    tick() {
      const now = Date.now();
      if (now >= this.nextRefresh && !this.busy) this.refresh();
      const event = selectEvent(this.events,this.config,now);
      if (!event) { this.empty(this.config.fallback); return; }
      const live = event.start <= now;
      const key = JSON.stringify([event,live]);
      if (key !== this.eventKey) {
        this.eventKey = key;
        this.hidden = false;
        this.querySelector('[data-event]').hidden = false;
        this.querySelector('[data-status]').hidden = true;
        const set = (selector,value) => { this.querySelector(selector).textContent = value; };
        set('[data-title]',displayEventTitle(event.title));
        set('[data-organization]',event.organization);
        this.querySelector('[data-organization]').hidden = !event.organization;
        set('[data-location]',event.location);
        set('[data-description]',plain(event.description).replace(/^\s*SPRPLX_\w+:.*$/gm,'').trim());
        this.querySelector('[data-description]').hidden = !this.config.showDescription || !event.description;
        this.querySelector('[data-location]').hidden = !this.config.showLocation || !event.location;
        const date = this.querySelector('[data-date]');
        date.dateTime = new Date(event.start).toISOString();
        let formatter;
        try { formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en',{dateStyle:'medium',...(event.allDay ? {} : {timeStyle:'short'}),timeZone:event.zone}); }
        catch { formatter = new Intl.DateTimeFormat('en',{dateStyle:'medium',timeZone:'UTC'}); }
        date.textContent = formatter.format(event.start) + (event.allDay ? '' : ' · ' + event.zone);
        date.hidden = !this.config.showDate;
        set('[data-timer-label]', live ? this.config.labels.ends : this.config.labels.starts);
        const cta = this.querySelector('[data-cta]');
        const link = safeLink(event.link,location.origin) || safeLink(this.config.ctaUrl,location.origin);
        cta.hidden = !this.config.showCta || !link;
        if (link) cta.href = link; else cta.removeAttribute('href');
      }
      const seconds = Math.max(0, Math.ceil(((live ? event.end : event.start)-now)/1000));
      const values = [Math.floor(seconds/86400),Math.floor(seconds/3600)%24,Math.floor(seconds/60)%60,seconds%60];
      this.querySelectorAll('[data-value]').forEach((node,i) => { const value = String(values[i]).padStart(2,'0'); if (node.textContent !== value) node.textContent = value; });
    }
  });
}
